import request from "@/utils/request";
// 创建主课题
export const createTopic =(data) =>{
    return request({
        url: "/businessservice/hostTopic/create",
        method:"post",
        data: data
    })
}
// 更新主课题
export const updateTopic =(data) =>{
    return request({
        url: "/businessservice/hostTopic/update",
        method:"post",
        data: data
    })
}
// 分页查询主课题
export const pageTopic =(data) =>{
    return request({
        url: "/businessservice/hostTopic/page",
        method:"post",
        data: data
    })
}

// 分页查询主课题
export const pageTopicWeb =(data) =>{
    return request({
        url: "/businessservice/hostTopic/pageWeb",
        method:"post",
        data: data
    })
}

export const infoTopic = (query) => {
    return request({
        url: "/businessservice/hostTopic/info",
        method: "get",
        params: query
    })
}

export const checkUserList = (query) => {
    return request({
        url: "/businessservice/hostTopic/checkUsers",
        method: "get",
        params: query
    })
}

export const checkUserSignList = (data) => {
    return request({
        url: "/businessservice/hostTopic/checkUsersSign",
        method:"post",
        data: data
    })
}

export const deleteTopic = (query) => {
    return request({
        url: "/businessservice/hostTopic/delete",
        method: "get",
        params: query
    })
}

export const listUserManagerTopic = (query) => {
    return request({
        url: "/businessservice/hostTopic/userManagerTopic",
        method: "get",
        params: query
    })
}

export const releaseTopic = (data) => {
    return request({
        url: "/businessservice/hostTopic/release",
        method:"post",
        data: data
    })
}

export const releaseTopicFile = (query) => {
    return request({
        url: "/businessservice/hostTopic/releaseFiles",
        method: "get",
        params: query
    })
}